import { TestExecution } from '../../../data/models'

export class ExamState {
  public testExecution: TestExecution
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/exam-state/exam-state.ts